<script>
export default
{
    name: 'app-footer',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='app-footer'>
                <div class='link'><router-link to='privacy-policy'>Politique de confidentialité</router-link></div>
                <div class='link'><router-link to='eula'>Conditions générales d'utilisation</router-link></div>
                {/* <div class='link'><router-link to='about-us'>Qui sommes-nous</router-link></div> */}
                <div class='link'><router-link to='contact-us'>Nous contacter</router-link></div>
                <div class='left'>Copyright © {new Date().getFullYear()} Ma Ville. Tous droits réservés.</div>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.app-footer
{

    background: var(--theme-secondary-color);
    display: flex;
    flex-direction: column;
    padding: 2vh 4vw;
    font-size: 2.8vw;

    .OnTablet({
        flex-direction: row-reverse;
        font-size: 1.6vw;
    });

    .OnDesktop({
        padding: 2vh 7vw;
        font-size: 0.8vw;
    });

    & .left
    {
        margin-right: auto;
        margin-left: 1vw;

        .OnDesktop({ margin-left: 2vw; });
    }

    & .link
    {
        margin: 0 1vw;

        .OnDesktop({ margin: 0 2vw; });

        &:hover
        {
            color: var(--theme-accent-color);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/AppFooter.vue